import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.1875 4H4.8125C3.91062 4 3.1875 4.73125 3.1875 5.625V15.375C3.1875 16.2688 3.91062 17 4.8125 17H8.0625V15.375H4.8125V7.25H16.1875V15.375H12.9375V17H16.1875C17.0813 17 17.8125 16.2688 17.8125 15.375V5.625C17.8125 4.73125 17.0894 4 16.1875 4ZM10.5 8.875L7.25 12.125H9.6875V17H11.3125V12.125H13.75L10.5 8.875Z" fill="currentColor" />
  </svg>
);
